<template>
  <div class="columns is-marginless main">
    <div class="column is-narrow has-background-white-bis sidebar">
      <RouterView name="master" :key="$route.fullPath" />
    </div>

    <div class="column details">
      <RouterView name="details" :key="$route.fullPath" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Ads'
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/style.scss';

.main {
  height: 100%;
}

.details {
  overflow-y: scroll;
}

.main .sidebar {
  min-width: 24rem;
  border-right-color: $grey-lightest;
  border-right-style: solid;
  border-right-width: 1px;
  overflow-y: scroll;
}
</style>
